var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sui-form", { attrs: { size: "medium" } }, [
    _c("div", { staticClass: "section portfolio-information" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [_c("sui-header", { tag: "h5" }, [_vm._v("PORTFOLIO INFORMATION")])],
        1
      ),
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Account Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.cashRequest.Financial_Account_Name__c
                                  .$model,
                              expression:
                                "$v.cashRequest.Financial_Account_Name__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.isSubmitted &&
                              _vm.$v.cashRequest.Financial_Account_Name__c
                                .$error,
                          },
                          attrs: {
                            type: "text",
                            name: "account-name",
                            placeholder: "Account Name",
                          },
                          domProps: {
                            value:
                              _vm.$v.cashRequest.Financial_Account_Name__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.cashRequest.Financial_Account_Name__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.isSubmitted &&
                        !_vm.$v.cashRequest.Financial_Account_Name__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the account name. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Account Number")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.cashRequest.Custodian_Account_Number__c
                                  .$model,
                              expression:
                                "$v.cashRequest.Custodian_Account_Number__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.isSubmitted &&
                              _vm.$v.cashRequest.Custodian_Account_Number__c
                                .$error,
                          },
                          attrs: {
                            type: "text",
                            name: "account-number",
                            placeholder: "Account Number",
                          },
                          domProps: {
                            value:
                              _vm.$v.cashRequest.Custodian_Account_Number__c
                                .$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.cashRequest.Custodian_Account_Number__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.isSubmitted &&
                        !_vm.$v.cashRequest.Custodian_Account_Number__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the account number. "),
                            ])
                          : _vm._e(),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Custodian")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.cashRequest.Custodian__c.$model,
                              expression: "$v.cashRequest.Custodian__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.isSubmitted &&
                              _vm.$v.cashRequest.Custodian__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "custodian",
                            placeholder: "Custodian",
                          },
                          domProps: {
                            value: _vm.$v.cashRequest.Custodian__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.cashRequest.Custodian__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.isSubmitted &&
                        !_vm.$v.cashRequest.Custodian__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the custodian. "),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Advisor")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cashRequest.Advisor__c,
                              expression: "cashRequest.Advisor__c",
                            },
                          ],
                          attrs: {
                            type: "text",
                            name: "advisor",
                            placeholder: "Advisor",
                          },
                          domProps: { value: _vm.cashRequest.Advisor__c },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.cashRequest,
                                "Advisor__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("sui-form-field", { attrs: { required: "" } }, [
                        _c("label", [_vm._v("Relationship Name")]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value:
                                _vm.$v.cashRequest.Relationship_Name__c.$model,
                              expression:
                                "$v.cashRequest.Relationship_Name__c.$model",
                              modifiers: { trim: true },
                            },
                          ],
                          class: {
                            "is-invalid":
                              _vm.isSubmitted &&
                              _vm.$v.cashRequest.Relationship_Name__c.$error,
                          },
                          attrs: {
                            type: "text",
                            name: "relationship-name",
                            placeholder: "Relationship Name",
                          },
                          domProps: {
                            value:
                              _vm.$v.cashRequest.Relationship_Name__c.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.cashRequest.Relationship_Name__c,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm.isSubmitted &&
                        !_vm.$v.cashRequest.Relationship_Name__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Enter the relationship name. "),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "section cash-request" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [_c("sui-header", { tag: "h5" }, [_vm._v("CASH REQUEST")])],
        1
      ),
      _c(
        "div",
        { staticClass: "section-content" },
        [
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Cash Request Type")]),
                          _c("sui-dropdown", {
                            class: {
                              "is-invalid":
                                _vm.isSubmitted &&
                                _vm.$v.cashRequest.Cash_Request_Type__c.$error,
                            },
                            attrs: {
                              placeholder: "Cash Request Type",
                              selection: "",
                              direction: "downward",
                              options: _vm.cashRequestTypeOptions,
                            },
                            model: {
                              value:
                                _vm.$v.cashRequest.Cash_Request_Type__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.cashRequest.Cash_Request_Type__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression:
                                "$v.cashRequest.Cash_Request_Type__c.$model",
                            },
                          }),
                          _vm.isSubmitted &&
                          !_vm.$v.cashRequest.Cash_Request_Type__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter the cash request type. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "sui-grid-column",
                    { attrs: { width: 8 } },
                    [
                      _c(
                        "sui-form-field",
                        { attrs: { required: "" } },
                        [
                          _c("label", [_vm._v("Amount")]),
                          _c("currency-input", {
                            class: {
                              "is-invalid":
                                _vm.isSubmitted &&
                                _vm.$v.cashRequest.Amount__c.$error,
                            },
                            attrs: { name: "amount", placeholder: "Amount" },
                            model: {
                              value: _vm.$v.cashRequest.Amount__c.$model,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.$v.cashRequest.Amount__c,
                                  "$model",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "$v.cashRequest.Amount__c.$model",
                            },
                          }),
                          _vm.isSubmitted &&
                          !_vm.$v.cashRequest.Amount__c.required
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(" Enter an amount. "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    [
                      _c("sui-form-field", [
                        _c("label", [_vm._v("Notes")]),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cashRequest.Cash_Request_Notes__c,
                              expression: "cashRequest.Cash_Request_Notes__c",
                            },
                          ],
                          attrs: { name: "cash-management-notes", rows: "3" },
                          domProps: {
                            value: _vm.cashRequest.Cash_Request_Notes__c,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.cashRequest,
                                "Cash_Request_Notes__c",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }